import { User, UserManager, WebStorageStateStore } from 'oidc-client-ts';

if (!process.env.REACT_APP_AUTH_AUTHORITY || !process.env.REACT_APP_AUTH_CLIENT_ID) {
  // eslint-disable-next-line no-console
  console.error(
    '[auth.service] Missing SSO config. Create a .env file with:\n' +
      '  REACT_APP_AUTH_AUTHORITY=https://access-dev.healthcare.elsevier.com/realms/h\n' +
      '  REACT_APP_AUTH_CLIENT_ID=hm-console\n' +
      'Then restart the dev server (webpack does not hot-reload .env changes).'
  );
}

// Singleton — one instance for the entire app lifetime.
// Never instantiate UserManager inside a hook or component.
const userManager = new UserManager({
  authority: process.env.REACT_APP_AUTH_AUTHORITY as string,
  client_id: process.env.REACT_APP_AUTH_CLIENT_ID as string,
  redirect_uri: `${window.location.origin}/`,
  post_logout_redirect_uri: `${window.location.origin}/`,
  response_type: 'code',
  scope: 'openid profile email',
  loadUserInfo: true,
  automaticSilentRenew: true,
  userStore: new WebStorageStateStore({ store: window.localStorage })
});

export const getUser = (): Promise<User | null> => userManager.getUser();

export const login = (): Promise<void> => userManager.signinRedirect();

export const logout = (): Promise<void> => userManager.signoutRedirect({ post_logout_redirect_uri: `${window.location.origin}/` });

export const signinCallback = (): Promise<User> => userManager.signinRedirectCallback();

export const renewToken = (): Promise<User | null> => userManager.signinSilent();

export const onSilentRenewError = (callback: (error: Error) => void): (() => void) => {
  userManager.events.addSilentRenewError(callback);
  return () => userManager.events.removeSilentRenewError(callback);
};
